import React from 'react';
import { Link } from '@material-ui/core';
import { Col, Container, Row } from 'react-bootstrap';
const Footer = () => (

    <div className="main-footer text-center">
        <Container>
            <Row className="row-sm">
                <Col md={6} className="col-md-6 mobile-text-right">
                    {/* <span>Copyright ©  {new Date().getFullYear()} <Link href="https://dturn.io" target="_blank" className='text-danger'>dturn IT Solutions (P) Ltd</Link>. All rights reserved.</span> */}
                    <span>Copyright ©  {new Date().getFullYear()} <Link href="https://trackingacademy.in/" target="_blank" className='text-danger'>Tracking Academy</Link>. All rights reserved.</span>
                </Col>
                <Col md={6} className="col-md-6 mobile-text-right">
                    {/* <span>Powered by <Link className='text-primary' href="https://amytechnologies.in/" target="_blank">AMY Technologies</Link> </span>*/}
                </Col> 
            </Row>
        </Container>
    </div>
);

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
